import styled from "styled-components";
import { injectIntl } from "react-intl";
import useKeyDown from "../hooks/useKeyDown";
import React from "react";
import {
  Button as StyledButton,
  ButtonInner,
} from "../../../../components3/src/Button/styled";

const Overlay = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);

  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
`;

const Main = styled.div`
  background: ${(p) => p.theme.colors.surface};
  padding: 25px;
  border-radius: 20px;
  min-width: ${(p) => (p.minWidth ? p.minWidth : "400px")};
  display: flex;
  flex-direction: column;
  user-select: text;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px 0px,
    rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;
  max-height: 100vh;
  overflow-y: auto;
`;

const CloseIcon = styled.i`
  font-size: 24px;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

const StyledTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Content = styled.div`
  flex: 1;
`;

const Button = injectIntl(({ label, btnType, onClick, disabled, intl }) => {
  return (
    <StyledButton
      disabled={disabled}
      onClick={onClick}
      type="button"
      btnType={btnType}
    >
      <ButtonInner>
        {label ? intl.formatMessage({ id: label }) : ""}
      </ButtonInner>
    </StyledButton>
  );
});

const StyledBottom = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
`;

const Left = styled.div``;
const Right = styled.div`
  display: flex;
`;

const Bottom = (props) => {
  const {
    cancelLabel = "Cancel",
    cancel = () => alert("No cancel set"),
    primaryLabel = null,
    primary,
    primaryDisabled = false,
    secondaryLabel = null,
    secondary,
    secondaryDisabled = false,
  } = props;
  useKeyDown("Escape", cancel);

  return (
    <StyledBottom>
      <Left>
        <Button
          type="button"
          btnType="cancel"
          label={cancelLabel}
          onClick={cancel}
        />
      </Left>
      <Right>
        {secondaryLabel && secondary && (
          <Button
            disabled={secondaryDisabled}
            label={secondaryLabel}
            btnType="secondary"
            onClick={secondary}
          />
        )}
        {primaryLabel && primary && (
          <Button
            disabled={primaryDisabled}
            label={primaryLabel}
            btnType="primary"
            onClick={primary}
          />
        )}
      </Right>
    </StyledBottom>
  );
};

const Top = injectIntl(({ label, cancel, intl }) => {
  return (
    <StyledTop>
      <h1>{label ? intl.formatMessage({ id: label }) : ""}</h1>
      {cancel && <CloseIcon onClick={cancel} className="fal fa-times" />}
    </StyledTop>
  );
});

const Modal = {
  Overlay,
  Main,
  Top,
  Content,
  Bottom,
  Button,
};

export default Modal;
